export default __webpack_public_path__ + "static/media/GrandstandBackground.92f80847.png";